<template>
	<form method="POST" id="PaymentForm" :action="stripe_action" class="form_style" v-on:submit.prevent.once data-cc-on-file="false" :data-stripe-publishable-key="this.stripe_key">
		<div class="wrapper">
			<div class="form_style">
				<p class="half">
					<label for="reference" class="required">Reference</label>
					<input type="text" id="reference" name="reference" v-model="reference">
					<span class="validation-error" v-if="this.validationErrors.reference">{{ this.validationErrors.reference }}</span>
				</p>
				<p class="half">
					<label for="amount" class="required">Amount to Pay</label>
					<span class="input_extra">&pound;</span>
					<input type="text" id="amount" name="amount" v-model="amount">
					<span class="validation-error" v-if="this.validationErrors.amount">{{ this.validationErrors.amount }}</span>
				</p>
				<p>
					<label for="email_address" class="required">Your Email Address</label>
					<input type="text" id="email_address" name="email_address" v-model="email_address">
					<span class="validation-error" v-if="this.validationErrors.email_address">{{ this.validationErrors.email_address }}</span>
				</p>
				<p>
					<label for="name_on_card" class="required">Name on Card</label>
					<input type="text" id="name_on_card" name="name_on_card" v-model="name_on_card">
					<span class="validation-error" v-if="this.validationErrors.name_on_card">{{ this.validationErrors.name_on_card }}</span>
				</p>
				<div class="fake_p">
					<label for="card_number" class="required">Card Number</label>
					<div id="card_number"></div>
				</div>
				<div class="fake_p half">
					<label for="card_expiry" class="required">Expiry Date</label>
					<div id="card_expiry"></div>
				</div>
				<div class="fake_p half">
					<label for="card_cvc" class="required">CVC <small>required</small></label>
					<div id="card_cvc"></div>
				</div>
				<p style="justify-content: center; font-size: 12px;">Please note, paymenets are handled by Stripe. Stone and Surfaces never receive your card details.</p>
				<p style="justify-content: flex-end"><a href="https://stripe.com/" target="_BLANK"><img src="/images/powered_by_stripe.png" /></a><br><span class="stripe_ssl_logo"></span></p>
				<div id="card_errors"></div>
				<input type="hidden" name="_token" :value="csrf">
				<input type="hidden" name="billing_address" v-model="stripe_billing_address">
				<input type="hidden" name="stripe_method" value="card">
			</div>

			<div class="terms_box" v-html="terms"></div>

			<p class="styled_checkboxes">
				<input type="checkbox" name="agree" id="agree" value="1" v-model="agree">
				<label for="agree"><span>I agree with the <a href="/terms-and-conditions-for-the-sale-of-products" taget="_blank">Terms of Use</a></span></label>
			</p>

			<p>
				<button id="proceed_button" class="button wide upper green arrow" :disabled="submittable == false || agree == false" v-on:click.prevent="placeOrder()">Place Order</button>
			</p>

		</div>
	</form>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
	props: [
		'terms'
	],
	data: () => {
		return {
			validationErrors: {
				reference: null,
				amount: null,
				name_on_card: null
			},
			csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
			reference: '',
			amount: 0,
			email_address: '',
			name_on_card: '',
			stripe_action: '/create-stripe-payment',
			stripe_handler: '/manual-stripe-handler',

			stripe_key: process.env.MIX_STRIPE_KEY,
			stripe_billing_address: '',
			submittable: true,
			agree: false,
			payment_method: 'card'
		}
	},

	mounted() {
		initialiseStripe(this.stripe_key);
	},

	methods: {
		...mapActions(["addAlert"]),

		// THE PLACE ORDER BUTTON HAS BEEN CLICKED, HANDLE WHAT HAPPENS NEXT
		placeOrder: function() {

			this.submittable = false;
			$('#proceed_button').removeClass('arrow').addClass('spinner');

			$('#PaymentForm').attr('action', this.stripe_action);

			var validated = true;
			if (this.reference=='') {
				validated = false;
				this.validationErrors.reference = "Please enter a payment reference";
				this.addAlert({
					alertClass: 'alert-danger', 
					alertMessage: '<strong>Error</strong> Please enter a payment reference', 
					alertImportant: false,
				})
				$('#proceed_button').removeClass('spinner').addClass('arrow').prop("disabled", false);
				this.submittable = true;
				return false;
			}
			if (this.amount=='') {
				validated = false;
				this.validationErrors.amount = "Please enter the amount you wish to pay";
				this.addAlert({
					alertClass: 'alert-danger', 
					alertMessage: '<strong>Error</strong> Please enter the amount you wish to pay', 
					alertImportant: false,
				})
				$('#proceed_button').removeClass('spinner').addClass('arrow').prop("disabled", false);
				this.submittable = true;
				return false;
			}
			if (this.email_address=='') {
				validated = false;
				this.validationErrors.email_address = "Please enter your email address";
				this.addAlert({
					alertClass: 'alert-danger', 
					alertMessage: '<strong>Error</strong> Please enter your email address', 
					alertImportant: false,
				})
				$('#proceed_button').removeClass('spinner').addClass('arrow').prop("disabled", false);
				this.submittable = true;
				return false;
			}
			if (this.name_on_card=='') {
				validated = false;
				this.validationErrors.name_on_card = "Please enter the name on your card";
				this.addAlert({
					alertClass: 'alert-danger', 
					alertMessage: '<strong>Error</strong> Please enter the name on card', 
					alertImportant: false,
				})
				$('#proceed_button').removeClass('spinner').addClass('arrow').prop("disabled", false);
				this.submittable = true;
				return false;
			}

			if (validated) {
				var stripe_key = this.stripe_key;
				var form_id  = 'PaymentForm';
				var reference_field  = 'reference';
				var amount_field  = 'amount';
				var email_address_field  = 'email_address';
				var name_on_card_field  = 'name_on_card';
				var card_errors_div  = 'card_errors';
				var stripe_handler = this.stripe_handler;
				this.submitStripe(stripe_key,form_id,reference_field,amount_field,email_address_field,name_on_card_field,card_errors_div,stripe_handler);
			}
		},

		submitStripe: function(stripe_key, form_id, reference_field, amount_field, email_address_field, name_on_card_field, card_errors_div, stripe_handler) {

			// Handle form submission
			form = document.getElementById(form_id);
			var reference = document.getElementById(reference_field).value;
			var amount = document.getElementById(amount_field).value;
			var email_address = document.getElementById(email_address_field).value;
			var cardholderName = document.getElementById(name_on_card_field).value;
			errors_div = card_errors_div;
			var self = this;

			stripe.createPaymentMethod('card', cardNumber, {
				billing_details: {
					name: cardholderName,
					email: email_address,
				},
			}).then(function(result) {
				if (result.error) {
					// Show error in payment form
					$('#proceed_button').removeClass('spinner').addClass('arrow').prop("disabled", false);
					self.submittable = true;
					showErrorMessage(result.error.message);
				} else {
					// Otherwise send paymentMethod.id to your server (see Step 2)
					fetch(stripe_handler, {
						method: 'POST',
						headers: {
							"Content-Type": "application/json",
							"Accept": "application/json",
							"X-Requested-With": "XMLHttpRequest",
							"X-CSRF-Token": $('input[name="_token"]').val()
						},
						body: JSON.stringify({ payment_method_id: result.paymentMethod.id, reference: reference, amount: amount, email_address: email_address })
					}).then(function (result) {
						// Handle server response (see Step 3)
						result.json().then(function (json) {
							self.handleServerResponse(json, form_id, stripe_handler);
						})
					});
				}
			});
		},

		handleServerResponse: function(response, form_id, stripe_handler) {
			var self = this;
			var form = document.getElementById(form_id);
			if (response.error) {
				// Show error from server on payment form
				$('#proceed_button').removeClass('spinner').addClass('arrow').prop("disabled", false);
				showErrorMessage(response.error);
			} else if (response.requires_action) {
				// Use Stripe.js to handle required card action
				stripe.handleCardAction(
					response.payment_intent_client_secret
				).then(function(result) {
					if (result.error) {
						// Show error in payment form
						$('#proceed_button').removeClass('spinner').addClass('arrow').prop("disabled", false);
						self.submittable = true;
						showErrorMessage(result.error.message);
					} else {
						// The card action has been handled
						// The PaymentIntent can be confirmed again on the server
						fetch(stripe_handler, {
							method: 'POST',
							headers: {
								"Content-Type": "application/json",
								"Accept": "application/json",
								"X-Requested-With": "XMLHttpRequest",
								"X-CSRF-Token": $('input[name="_token"]').val()
							},
							body: JSON.stringify({ payment_intent_id: result.paymentIntent.id })
						}).then(function(confirmResult) {
							return confirmResult.json();
						}).then(self.handleServerResponse);
					}
				});
			} else {
				// Show success message
				form.submit();
			}
		}

	},

};

function showErrorMessage(message = '') {
	var feedback_box = document.getElementById(errors_div);
	feedback_box.innerHTML = message;
}
var stripe = '';
var form = '';
var errors_div = '';
var elements;
var cardNumber;
var cardExpiry;
var cardCvc;
function initialiseStripe(stripe_key) {
	
	// Create a Stripe client
	stripe = Stripe(stripe_key);

	// Define element styles
	var elementStyles = {
		base: {
			iconColor: '#3ba935',
			color: '#333',
			lineHeight: '1.4em',
			fontSize: '14px',
			':-webkit-autofill': {
				color: '#67b9b1',
			},
		},
		invalid: {
			iconColor: '#c82333',
			color: '#c82333',
		},
	};

	// Define element classes
	var elementClasses = {
		focus: 'focus',
		empty: 'empty',
		invalid: 'invalid',
	};

	// Create an instance of Elements
	elements = stripe.elements();

	// Create the elements
	cardNumber = elements.create('cardNumber', { style: elementStyles, classes: elementClasses });
	cardNumber.mount('#card_number');

	cardExpiry = elements.create('cardExpiry', { style: elementStyles, classes: elementClasses });
	cardExpiry.mount('#card_expiry');

	cardCvc = elements.create('cardCvc', { style: elementStyles, classes: elementClasses });
	cardCvc.mount('#card_cvc');
}
</script>